<template>
	<div class="product_content">
        <channel-banner></channel-banner>
        <!-- 产品主页 -->
		<div class="main-content">
			<div class="container">
				<div class="item" v-for="(item, index) in productList" :key="item.id">
					<div class="title">
						{{item.name}}
                        <div class="title_right" @click="knowProductDetail(index, item.id)">
                            <span>了解详情</span>
                            <span class="arrow">
                                <i class="el-icon-arrow-right"></i>
                                <i class="el-icon-arrow-right"></i>
                            </span>
                        </div>
					</div>
					<div class="description">
						{{item.description.length > 120 ? item.description.substring(0,120) + "..." : item.description}}
					</div>
					<div class="button" @click="singupOnline(item.id)">
						<span>在线签约</span>	
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { queryProductByType } from '@/api/channel/product.js'
    import ChannelBanner from '../../../components/channel/channelBanner.vue'
    export default {
        components: {
            ChannelBanner,
        },
        data() {
            return {
                productList: [],
            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                let type = 0;
                queryProductByType(type).then(res => {
                    this.productList = res.data.list;
                })
            },
            //了解详情
            knowProductDetail(i, id) {
                let channelId = 13 + i;
                this.$router.push({
                    path: '/productDetail',
                    query: {
                        channelId,
                        id
                    }
                });
            },
            //在线签约
            singupOnline(id) {
                this.$router.push({path: '/onlineSignup',query: {id:id}})
            },
        }
    }
</script>

<style lang="scss" scoped="scoped">
    .product_content {
        margin-top: 80px;
        .main-content {
            min-width: 1330px;
            padding: 0 15%;
            margin-top: 75px;
            .container {
                display: flex;
                justify-content: space-between;
                flex-flow: row wrap;
                align-items: center;
                margin: 50px 0;
                .item {
                    display: flex;
                    flex-direction: column;
                    width: 642px;
                    height: 220px;
                    border: 1px solid #e5e5e5;
                    margin-bottom: 44px;
                    .title {
                        height: 90px;
                        margin: 0 32px;
                        border-bottom: 1px solid #e5e5e5;
                        font-size: 28px;
                        color: #575757;
                        line-height: 110px;
                        .title_right {
                            float: right;
                            font-size: 16px;
                            color: #507df1;
                            .arrow {
                                margin-left: 10px;
                            }
                        }
                    }
                    .description {
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        height: 95px;
                        margin: 0 32px;
                        font-size: 12px;
                        color: rgb(106, 106, 106);
                        line-height: 24px;
                        letter-spacing: 2px;
                    }
                    .button {
                        display: flex;
                        justify-content: flex-end;
                        span {
                            display: inline-block;
                            width: 150px;
                            height: 35px;
                            color: white;
                            line-height: 35px;
                            text-align: center;
                            background-color: #507df1;
                        }
                    }
                }
                .item:hover {
                    background-image: url('../../../assets/home/product_background.png');
                    border-color: #507df1;
                    .title {
                        color: #fff;
                        .title_right {
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                    .description {
                        color: #ffffff;
                    }
                    .button {
                        color: #ffffff;
                        span {
                            background-color: #ffffff;
                            color: #507df1;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>